export const CPAT_LESSON_MODE_INSTRUCTIONAL = "Instructional";  // obsolete, replaced by "Demo"
export const CPAT_LESSON_MODE_DEMO = "Demo";
export const CPAT_LESSON_MODE_PRACTICE = "Practice";
export const CPAT_LESSON_MODE_TEST = "Test";    // obsolete, replaced by "Perform"
export const CPAT_LESSON_MODE_PERFORM = "Perform";
export const CPAT_LESSON_MODE_UNKNOWN = "Unknown";
export const LMS_LESSON_MODE_BROWSE = "browse";
export const LMS_LESSON_MODE_REVIEW = "review";
export const LMS_LESSON_MODE_NORMAL = "normal";
